import _ from 'lodash';
import { GET_NOT_SENT_EXAMS } from '../actions/answersActions';

/**
 * Manejo de la parte del estado correspondiente a exámenes no enviados.
 * Permite la actualización de exámenes no enviados.
 *
 * @export
 * @param {*} [state={}] : estado de la aplicación
 * @param {*} action : operación a realizar sobre el estado (correspondiente a los exámenes no enviados)
 * @returns El estado con la modificación/acción realizada.
 */
export default function(state = {}, action) {
  switch (action.type) {
    case GET_NOT_SENT_EXAMS:
      const notSentExams = action.payload.exams;
      const pagination = action.payload.links;
      return {...state, notSentExams: notSentExams, pagination: pagination};
    default:
      return state;
  }
} 